/*
This file is located in the main branch
Last time the file was updated (UTC): [08.08.2024 13:21:23]
Permissions to update outside the main branch: [false]
*/

import { DropDown } from '@finbeat/react-toolkit';
import { ReactNode } from 'react';

export default function GetOptions(
    arr: DropDown[],
    addEmpty?: boolean,
    disabled = true,
    emptyNode: ReactNode | null = null
) {
    return (
        addEmpty
            ? [
                  <option key={-1} value="" disabled={disabled}>
                      {emptyNode}
                  </option>,
              ]
            : []
    ).concat(
        arr.map((x) => (
            <option key={x.id} value={x.id ?? undefined}>
                {x.name}
            </option>
        ))
    );
}
